<template>
    <div class="create-notification">
        <div class="notifications">
            <div class="form">
                <center>
                    <h3>Crear Notificación</h3>
                </center>
                <div class="form-inputs">
                    <div>
                        <div>
                            <label for="">Titulo</label>
                            <input type="text" name="" id="" v-model="title">
                        </div>
                        <div>
                            <label for="">Fecha</label>
                            <input type="date" name="" id="" v-model="date" :min="minDate">
                        </div>
                        <div class="check">
                            <input type="checkbox" name="" id="" ref="delivery">
                            <label for="">Entrega inmediata</label>
                        </div>
                        <div>
                            <label for="">Tipo</label>
                            <div v-for="(item, index) in notificationsType" :key="index">
                                <input type="radio" :value="item.name" v-model="type">
                                <label for="">{{item.name}}</label>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label for="">Detalles</label>
                            <textarea name="" id="" cols="30" rows="15" v-model="details"></textarea>
                        </div>
                    </div>
                </div>
                <center>
                    <div class="group">
                        <h4>Seleccionar grupo de modelos</h4>
                        <div>
                            <div>
                                <button :class="{'select': isTurnoM}" @click="selectedByTurno('mañana')">Turno mañana</button>
                                <button :class="{'select': isTurnoT}" @click="selectedByTurno('tarde')">Turno tarde</button>
                                <button :class="{'select': isTurnoN}" @click="selectedByTurno('noche')">Turno noche</button>
                            </div>
                            <div>
                                <button :class="{'select': isTypeS}" @click="selectedByType('satelite')">Satelite</button>
                                <button :class="{'select': isTypeL}" @click="selectedByType('local')">Local</button>
                            </div>
                            <div>
                                <button :class="{'select': isStatusC}" @click="selectedByStatus('En creacion')">En creación</button>
                                <button :class="{'select': isStatusP}" @click="selectedByStatus('Pendiente')">Pendientes</button>
                                <button :class="{'select': isStatusA}" @click="selectedByStatus('Aprobada')">Aprobadas</button>
                            </div>
                        </div>
                    </div>
                    <button @click="createNotification">Crear Notificación</button>
                </center>
            </div>
        </div>
        <div class="models">
            <div class="list" v-infinite-scroll="loadMoreModels" infinite-scroll-disabled="busyModels" infinite-scroll-distance="500">
                <center>
                    <h3>Lista de Modelos</h3>
                    <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                    <div v-for="(item, index) in modelList" :key="index" @click="selectedByModel(item.model_id)" :class="{'select': item.select}">
                        <img :src="item.photo" alt="">
                        <div>
                            <label for="">{{ item.stagename }}</label>
                            <span>{{ item.turno }}</span>
                            <span>{{ item.tipo }}</span>
                        </div>
                    </div>
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'

export default {
    name: 'create-notification',
    data() {
        return {
            minDate: null,
            notificationsType: [],
            modelList: [],
            isTurnoM: false,
            isTurnoT: false,
            isTurnoN: false,
            isTypeS: false,
            isTypeL: false,
            isStatusC: false,
            isStatusP: false,
            isStatusA: false,
            isModel: false,
            title: null,
            date: null,
            details: null,
            type: null,
            limitModels: 20,
            offsetModels: 0,
            busyModels: false,
            listEndModels: false,
            itemFlagModels: false,
            searchValue: ''
        }
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.models = []
                this.getAllModels()
            }
        }
    },
    methods: {
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limitModels = 20
                this.offsetModels = 0
                this.modelList = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limitModels = 20
                this.offsetModels = 0
                this.modelList = []
                this.searchModel()
            }
        },
        onEnter () {
            this.searchModel()
        },
        searchModel() {
            this.modelSearch = false
            this.getNotificationModelList()
        },
        loadMoreModels() {
            if (this.searchValue !== '') {
                return
            }
            this.busyModels = true
            if (!this.listEndModels) {
                setTimeout(() => {
                    if (this.modelList.length < this.offsetModels) {
                        this.listEndModels = true
                        return
                    }
                    if (this.itemFlagModels) {
                        this.getNotificationModelList()
                        this.busyModels = false
                    } else {
                        this.loadMoreModels()
                    }
                }, 1000)
            }
        },
        createNotification() {
            if (!this.title) {
                return
            }
            if (!this.date && !this.$refs.delivery.checked) {
                return
            }
            if (!this.type) {
                return
            }
            if (!this.details) {
                return
            }
            var notificacion = {
                titulo: this.title,
                send_time: this.date,
                delivery: this.$refs.delivery.checked,
                type: this.type,
                who: this.$store.state.user.id,
                detalles: this.details,
                models: this.modelList.filter(item => item.select === true).map(item => { return item.model_id })
            }
            if (this.isTurnoM && !this.isTurnoT && !this.isTurnoN && !this.isTypeS && !this.isTypeL && !this.isStatusC && !this.isStatusP && !this.isStatusA && !this.isModel) {
                notificacion.group = 'dia'
            } else if (!this.isTurnoM && this.isTurnoT && !this.isTurnoN && !this.isTypeS && !this.isTypeL && !this.isStatusC && !this.isStatusP && !this.isStatusA && !this.isModel) {
                notificacion.group = 'tarde'
            } else if (!this.isTurnoM && !this.isTurnoT && this.isTurnoN && !this.isTypeS && !this.isTypeL && !this.isStatusC && !this.isStatusP && !this.isStatusA && !this.isModel) {
                notificacion.group = 'noche'
            } else if (!this.isTurnoM && !this.isTurnoT && !this.isTurnoN && this.isTypeS && !this.isTypeL && !this.isStatusC && !this.isStatusP && !this.isStatusA && !this.isModel) {
                notificacion.group = 'satelites'
            } else if (!this.isTurnoM && !this.isTurnoT && !this.isTurnoN && !this.isTypeS && this.isTypeL && !this.isStatusC && !this.isStatusP && !this.isStatusA && !this.isModel) {
                notificacion.group = 'local'
            } else if (!this.isTurnoM && !this.isTurnoT && !this.isTurnoN && !this.isTypeS && !this.isTypeL && this.isStatusC && !this.isStatusP && !this.isStatusA && !this.isModel) {
                notificacion.group = 'no_assoc'
            } else if (!this.isTurnoM && !this.isTurnoT && !this.isTurnoN && !this.isTypeS && !this.isTypeL && !this.isStatusC && this.isStatusP && !this.isStatusA && !this.isModel) {
                notificacion.group = 'pending'
            } else if (!this.isTurnoM && !this.isTurnoT && !this.isTurnoN && !this.isTypeS && !this.isTypeL && !this.isStatusC && !this.isStatusP && this.isStatusA && !this.isModel) {
                notificacion.group = 'approved'
            } else {
                notificacion.group = 'especifico'
            }
            API.createNotificationGroup(notificacion)
                .then((res) => {
                    if (res.status === 'entregada') {
                        this.$router.push({name: 'notificaciones-enviadas', params: {notification_id: res.notification_id}})
                    } else {
                        this.$router.push({name: 'notificaciones-pendientes', params: {notification_id: res.notification_id}})
                    }
                })
        },
        selectedByModel(id) {
            this.isModel = true
            this.modelList.map(item => { if (item.model_id === id) item.select = !item.select })
        },
        selectedByTurno(turno) {
            if (turno === 'mañana') {
                this.isTurnoM = !this.isTurnoM
                this.modelList.map(item => { if (item.turno === turno) item.select = this.isTurnoM })
            } else if (turno === 'tarde') {
                this.isTurnoT = !this.isTurnoT
                this.modelList.map(item => { if (item.turno === turno) item.select = this.isTurnoT })
            } else if (turno === 'noche') {
                this.isTurnoN = !this.isTurnoN
                this.modelList.map(item => { if (item.turno === turno) item.select = this.isTurnoN })
            }
        },
        selectedByType(type) {
            if (type === 'satelite') {
                this.isTypeS = !this.isTypeS
                this.modelList.map(item => { if (item.tipo === type) item.select = this.isTypeS })
            } else if (type === 'local') {
                this.isTypeL = !this.isTypeL
                this.modelList.map(item => { if (item.tipo === type) item.select = this.isTypeL })
            }
        },
        selectedByStatus(status) {
            if (status === 'En creacion') {
                this.isStatusC = !this.isStatusC
                this.modelList.map(item => { if (item.status === status) item.select = this.isStatusC })
            } else if (status === 'Pendiente') {
                this.isStatusP = !this.isStatusP
                this.modelList.map(item => { if (item.status === status) item.select = this.isStatusP })
            } else if (status === 'Aprobada') {
                this.isStatusA = !this.isStatusA
                this.modelList.map(item => { if (item.status === status) item.select = this.isStatusA })
            }
        },
        NotificationsTypes() {
            API.NotificationsTypes()
                .then((res) => {
                    this.notificationsType = res
                })
        },
        getNotificationModelList() {
            const limit = this.searchValue === '' ? this.limitModels : 'ALL'
            const offset = this.searchValue === '' ? this.offsetModels : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getNotificationModelList(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.modelList = res
                    } else {
                        res.map(item => this.modelList.push(item))
                        this.offsetModels += this.limitModels
                        this.itemFlagModels = true
                    }
                })
        }
    },
    mounted() {
        var dtToday = new Date()
        var month = dtToday.getMonth() + 1
        var day = dtToday.getDate()
        var year = dtToday.getFullYear()
        if (month < 10) {
            month = '0' + month.toString()
        }
        if (day < 10) {
            day = '0' + day.toString()
        }
        this.minDate = year + '-' + month + '-' + day
        this.NotificationsTypes()
        this.getNotificationModelList()
    }
}
</script>

<style scoped>
    .create-notification {
        background-color: #cdcdcd;
        height: 90vh;
        padding: 20px;
        color: #000;
        display: flex;
    }
    .create-notification > .notifications {
        width: 60%;
        height: 100%;
    }
    .create-notification > .notifications > .form{
        width: 100%;
        height: 100%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #8363b7;
    }
    .create-notification > .notifications > .form > center > h3 {
        color: #fff;
        width: 100%;
    }
    .create-notification > .notifications > .form > .form-inputs {
        width: 100%;
        display: flex;
    }
    .create-notification > .notifications > .form > .form-inputs > div {
        width: 50%;
        padding: 20px;
    }
    .create-notification > .notifications > .form > .form-inputs > div > div {
        padding: 10px;
       display: grid;
    }
    .create-notification > .notifications > .form > .form-inputs > div > div > label {
       color: #fff;
       font-weight: bold;
       font-size: 22px;
    }
    .create-notification > .notifications > .form > .form-inputs > div > div > input[type=text] {
        border-radius: 20px;
        text-align: center;
        height: 35px;
    }
    .create-notification > .notifications > .form > .form-inputs > div > div > input[type=date] {
        border-radius: 20px;
        text-align: center;
        height: 35px;
    }
    .create-notification > .notifications > .form > .form-inputs > div > div > textarea {
        border-radius: 20px;
        padding: 10px;
    }
    .create-notification > .notifications > .form > .form-inputs > div > .check {
        display: flex;
    }
    .create-notification > .notifications > .form > .form-inputs > div > .check > input{
        width: 30px;
        height: 30px;
        margin-right: 20px;
    }
    .create-notification > .notifications > .form > center > .group > h4{
        color: #fff;
        margin-bottom: 20px;
    }
    .create-notification > .notifications > .form > center > .group > div > div >button{
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 30px;
        border-radius: 30px;
        font-weight: bold;
    }
    .create-notification > .notifications > .form > center > .group > div > div > .select{
        background-color: #22bb33;
    }
    .create-notification > .notifications > .form > center > button{
        background-color: #e0b059;
        color: #fff;
        width: 300px;
        height: 50px;
        border-radius: 30px;
        font-weight: bold;
        margin-top: 30px;
    }
    .create-notification > .models {
        width: 40%;
        height: 100%;
        padding-left: 20px;
    }
    .create-notification > .models > .list{
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        padding: 20px;
        background-color: #585858;
    }
    .create-notification > .models > .list > center{
        height: 100%;
        overflow-y: auto;
    }
    .create-notification > .models > .list > center > input{
        width: 100%;
        height: 40px;
        border-radius: 20px;
        text-align: center;
    }
    .create-notification > .models > .list > center > h3{
        color: #fff;
    }
    .create-notification > .models > .list > center > div{
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 100px;
        position: relative;
        display: flex;
        padding: 10px 40px;
    }
    .create-notification > .models > .list > center > div > img{
        width: 80px;
        height: 80px;
        object-fit: cover;
        margin-right: 60px;
        border-radius: 50%;
    }
    .create-notification > .models > .list > center > div > div {
        display: grid;
        text-align: left;
    }
    .create-notification > .models > .list > center > .select{
        background-color: #22bb33;
    }
    .create-notification > .models > .list > center > .header-titles{
        border-style: dotted;
    }
    .create-notification > .models > .list > center > div > .border-label{
        width: 49%;
        padding-left: 0px;
        padding-right: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Notificaciones/CreateNotification.vue